import { render, staticRenderFns } from "./CandidateListReport.vue?vue&type=template&id=d0c64dc8"
import script from "./CandidateListReport.vue?vue&type=script&lang=js"
export * from "./CandidateListReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports